module.exports = __webpack_public_path__ + "img/MX.ee70e6a6.svg";